export default __webpack_public_path__ + "static/media/Group-6-Yono.204f5368.png";